import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const STRIPE_REDIRECT_STATUS = {
  ERROR: 'failed',
  SUCCESS: 'succeeded',
};

export const useAsyncPayment = ({ onSuccess, onError }) => {
  const [params] = useSearchParams();
  const httpState = Object.fromEntries(params);

  useEffect(() => {
    if (!(httpState.payment_intent || httpState.setup_intent)) {
      return;
    }

    if (httpState.redirect_status === STRIPE_REDIRECT_STATUS.ERROR) {
      onError(httpState);
    }

    if (httpState.redirect_status === STRIPE_REDIRECT_STATUS.SUCCESS) {
      onSuccess(httpState);
    }
  }, [httpState]);
};
